import styled from '@emotion/styled'
export const StyleHeaderWrapper = styled.header`
  background: ${(props: any) => props.theme.colors.white};
  box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 0px;
  z-index: 100;
`

export const StyleHeaderRow = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
`

export const StyleHeaderLogo = styled.img`
  height: 40px;
  @media (max-width: 480px) {
    height: 30px;
  }
`
